import { BitfSearchApiRequestPart } from '@bitf/core/api-call-state/bitf-search-api-request-part.builder';

export class BitfPSearchApiRequestPart extends BitfSearchApiRequestPart {
  constructor(params) {
    super(params);
  }
}
